import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    background: transparent;
    border-radius: 4px;
    border: solid 1px #b8b7b7;
    cursor: pointer;
    ${({ isChecked }) => isChecked &&
        css`
            background-color: #1D86FF;
        `
    };
    .check-icon{
        color: #ffffff;
        font-size: .777rem;
    };
`;